import { render, staticRenderFns } from "./registroPostulacion.vue?vue&type=template&id=8b3e6d32&scoped=true"
import script from "./registroPostulacion.vue?vue&type=script&lang=js"
export * from "./registroPostulacion.vue?vue&type=script&lang=js"
import style0 from "./registroPostulacion.vue?vue&type=style&index=0&id=8b3e6d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3e6d32",
  null
  
)

export default component.exports